import { inject, Injectable, signal } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { ApiService } from '../api.service';
import { User } from '../../../shared/models/user.model';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private _apiService = inject(ApiService);
  currentUser!: User;
  userName: string = '';
  loggedIn = signal<boolean>(false);

  constructor() {}

  getCurrentUser(): void {
    this._apiService
      .getCurrentUser()
      .pipe(
        map((user: User) => {
          this.currentUser = user;
          this.userName = user.name;
        }),
        tap(),
      )
      .subscribe();
  }

  get user(): User {
    if (!this.currentUser) {
      this.getCurrentUser();
    }
    return this.currentUser;
  }

  getUser(): Observable<User> {
    return this._apiService.getCurrentUser();
  }
}
